import { useEffect, useState } from "react";

export const useIsIOS = () => {
  const [isIOS, setIOS] = useState(false);

  useEffect(() => {
    let isApple = false;
    if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
      isApple = true;
    }
    setIOS(isApple);
  }, []);

  return isIOS;
};
